import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import type { ClassValue } from 'clsx';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';

/**
 * Helm dialog overlay directive (spartan layer).
 * Renders the semi-transparent backdrop behind an open dialog.
 * Attach to the element inside `hlm-dialog-content` that should be the overlay.
 */
@Component({
  selector: 'hlm-dialog-overlay, [hlmDialogOverlay]',
  standalone: true,
  hostDirectives: [],
  host: {
    '[class]': '_computedClass()',
    '[attr.data-state]': '_state()',
  },
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HlmDialogOverlayComponent {
  private readonly _dialogRef = inject(BrnDialogRef, { optional: true });

  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _state = computed(() => this._dialogRef?.state() ?? 'closed');

  protected readonly _computedClass = computed(() =>
    mergeClasses(
      'fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      this.userClass(),
    ),
  );
}
